// API Base URL - configured via environment variable at build time
// In production: set REACT_APP_API_URL in docker-compose or .env
// In development: defaults to localhost:8000
export const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";

// Legacy URLs (for reference - DO NOT USE)
// DigitalOcean: "https://tachafy-app-5hdge.ondigitalocean.app/tashafy-backend-python" 